import { render, staticRenderFns } from "./import-assembly-product-modal.vue?vue&type=template&id=b4171902&scoped=true&"
import script from "./import-assembly-product-modal.vue?vue&type=script&lang=js&"
export * from "./import-assembly-product-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4171902",
  null
  
)

export default component.exports